import Tesseract from "tesseract.js";
import { format, addMinutes } from "date-fns";

export function parseBool(str: string) {
  if (str != null && str === "true") {
    return true;
  }
  return false;
}

export function decodeJWToken(token: string) {
  return JSON.parse(atob(token.split(".")[1]));
}

export async function recognizeTextInImage(dataURL: string) {
  // Set the worker and core paths
  const workerOptions = {
    workerPath: "/assets/js/worker.min.js",
    corePath: "/assets/js/tesseract-core-simd-lstm.wasm.js",
    langPath: "/assets/data/",
    logger: (message: any) => console.debug(message), // Added type to fix TypeScript error
  };

  try {
    // Use the recognize method with the configured options
    const data = await Tesseract.recognize(dataURL, "eng", workerOptions);

    if ("data" in data) {
      return data.data;
    }
    return null;
  } catch (error) {
    console.error("Error in OCR processing:", error);
    return null;
  }
}

export function formatTime(time: number): string {
  const hours = Math.floor(time / 3600);
  const minutes = Math.floor((time % 3600) / 60);
  const secs = time % 60;
  return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${secs
    .toString()
    .padStart(2, "0")}`;
}

export function formatDate(
  date: Date | string,
  formatStr: string = "dd/MM/yyyy hh:mm a" // Adjusted for 12-hour format
) {
  if (date == null) {
    return "";
  }

  const inputDate = new Date(date);
  const istDate = addMinutes(inputDate, 330);

  return format(istDate, formatStr);
}

export const convertSecondsToHHMMSS = (seconds: number) => {
  if (seconds === 0) return "00:00:00";
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;
  return `${hrs.toString().padStart(2, "0")}:${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
};

export function parseDate(dateString: string) {
  // date string must be in this format "31/12/2024 04:54:16 PM"
  // use this method to get date in ISO format
  const [date, time, period] = dateString.split(" ");
  const [month, day, year] = date.split("-");
  const [h, minutes, seconds] = time.split(":");
  let hours = h;

  if (period === "PM" && parseInt(hours) !== 12) {
    hours = (parseInt(hours) + 12).toString();
  }

  if (period === "AM" && parseInt(hours) === 12) {
    hours = "00";
  }

  return new Date(`${month}/${day}/${year} ${hours}:${minutes}:${seconds}`);
}

export function getGenericURL(url: string): string {
  return process.env.NODE_ENV === "development"
    ? "/api" + url.replace(/.*?(?=\/dev)/, "")
    : url;
}
